// extracted by mini-css-extract-plugin
module.exports = {"column":"TimeLabels_column__3j0m_","item":"TimeLabels_item__3rgm8"};